import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TrackClickDirective } from '@os-components';
import { SewIcon, SewLink } from '@sew/ui-components-angular/standalone';

@Component({
    selector: 'ecs-service-teaser',
    templateUrl: './service-teaser.component.html',
    styleUrls: ['./service-teaser.component.scss'],
    imports: [SewIcon, SewLink, TrackClickDirective],
})
export class ServiceTeaserComponent {
    @Input() public icon = '';
    @Input() public linkText = '';
    @Input() public text = '';
    @Input() public trackClickEvent = '';

    @Output() public selectService = new EventEmitter<void>();

    public onSelectService() {
        this.selectService.emit();
    }
}
